import { type ExpenseReportFormSchema } from '@webapp/modules/expense/components/CreateExpenseReportForm'
import { type ExpenseStatusEnum } from '@webapp/modules/expense/entities/enums/ExpenseStatusEnum'
import {
  mapExpenseItemFormSchemaToItemPayload,
  type ExpenseItemPayload,
} from './mapExpenseItemFormSchemaToItemPayload'

export interface ExpenseRequestPayload {
  title: string
  department: number
  branch: number
  localCurrency: number
  travel: Nullable<number>
  notes: string
  next_approver: number
  status: number
  items: Record<string, ExpenseItemPayload>
  files: string[]
}

export const mapExpenseFormFieldsToCreatePayload = (
  formValues: ExpenseReportFormSchema,
  status: ExpenseStatusEnum
): ExpenseRequestPayload => {
  const itemsRecord = formValues.items.reduce<ExpenseRequestPayload['items']>(
    (acc, item, index) => {
      acc[String(index)] = mapExpenseItemFormSchemaToItemPayload(item)
      return acc
    },
    {}
  )

  return {
    title: formValues.title,
    department: formValues.department?.id ?? 0,
    branch: formValues.location?.id ?? 0,
    localCurrency: formValues.items[0]?.currency?.id ?? 0,
    travel: formValues.travel?.id ?? null,
    notes: formValues.notes,
    next_approver: formValues.nextApproverId ?? 0,
    status,
    items: itemsRecord,
    files: [],
  }
}
